import { PageEvent } from '@spartacus/storefront'
import { Cart } from '@spartacus/cart/base/root'

export class CheckoutPageEvent extends PageEvent {

  static readonly type = 'CheckoutPageEvent'

  cart?: Cart
  step?: number
}
